import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = ({ pageRange }) => {
    const height = 44 * (pageRange + 1)
    const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
        let yStrip = ind ? (44 * ind + 8) : 12

        if (ind === 0) {
            yStrip = 12
        } else if (ind === 1) {
            yStrip = 50
        } else {
            yStrip = 44 * (ind - 1) + 50
        }

        return (
            <React.Fragment key={ind}>
                {
                    ind ?
                        <>
                            <rect x='15' y={yStrip} rx='3' ry='3' width='100' height='14' />
                            <rect x='125' y={yStrip + 1} rx='3' ry='3' width='200' height='12' />
                            <rect x='340' y={yStrip + 1} rx='3' ry='3' width='100' height='12' />
                            <rect x='500' y={yStrip + 1} rx='3' ry='3' width='280' height='12' />
                            <rect x='810' y={yStrip + 1} rx='3' ry='3' width='30' height='12' />
                            <rect x='880' y={yStrip} rx='3' ry='3' width='100' height='12' />

                        </> :
                        <>
                            <rect x='15' y={yStrip} rx='3' ry='3' width='100' height='14' />
                            <rect x='125' y={yStrip + 1} rx='3' ry='3' width='100' height='12' />
                            <rect x='340' y={yStrip + 1} rx='3' ry='3' width='80' height='12' />
                            <rect x='500' y={yStrip + 1} rx='3' ry='3' width='100' height='12' />
                            <rect x='810' y={yStrip + 1} rx='3' ry='3' width='50' height='12' />
                            <rect x='880' y={yStrip + 1} rx='3' ry='3' width='70' height='12' />

                        </>
                }
            </React.Fragment>
        )
    })

    return (
        <ContentLoader
            speed={2}
            width={1120}
            height={height}
            viewBox={`0 0 1120 ${height}`}
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
        >
            <>
                {body}
            </>
        </ContentLoader>
    )
}

export default Loader